import cl from '../../styles.module.scss'
import { BasketList } from '../basket-list/basket-list'
import { BasketRedirectAlert } from '../basket-redirect-alert/basket-redirect-alert'

type BasketMainContentProps = {
	showAlert: boolean
}

export const BasketMainContent = ({ showAlert }: BasketMainContentProps) => {
	return (
		<div className={cl.basket__main}>
			{showAlert && <BasketRedirectAlert />}
			<BasketList />
		</div>
	)
}
